export function validateVipConversion({ amount, minRequired, balance }) {
  if (amount === '' || amount === null || amount === undefined) {
    return { valid: false, code: 'MINIMUM_NOT_MET' };
  }
  const num = Number(amount);
  if (Number.isNaN(num)) return { valid: false, code: 'NOT_INTEGER' };
  if (!Number.isInteger(num)) return { valid: false, code: 'NOT_INTEGER' };
  if (num < minRequired) return { valid: false, code: 'MINIMUM_NOT_MET' };
  if (num > balance) return { valid: false, code: 'INSUFFICIENT_BALANCE' };
  return { valid: true };
}

export const errorMessages = (minRequired) => ({
  MINIMUM_NOT_MET: `Minimum VP Required: ${minRequired}`,
  INSUFFICIENT_BALANCE: 'Not enough points.',
  NOT_INTEGER: 'Enter a whole number.',
  API_ERROR: 'Conversion failed. Try again.'
});
